import { Box, Button, Modal, Text } from "@repo/ui";
import { shouldShowAinaCameraDoubtOnboarding } from "@repo/utils";

import modalStyles from "./AinaUploadQuestionIntroModal.module.scss";
import { uploadQuestionIntroModalShellStyles } from "./modalShellStyles";

export type AinaUploadQuestionIntroModalProps = {
  open: boolean;
  noOfDoubts: number;
  onClose: () => void;
  onLetsTry: () => void;
};

export function AinaUploadQuestionIntroModal({
  open,
  noOfDoubts,
  onClose,
  onLetsTry,
}: AinaUploadQuestionIntroModalProps) {
  if (!open) {
    return null;
  }
  if (!shouldShowAinaCameraDoubtOnboarding(noOfDoubts)) {
    return null;
  }

  const body = (
    <Box className={modalStyles.card}>
      <Box
        onClick={onClose}
        className={modalStyles.closeButton}
        aria-label="Close"
      >
        <Text className={modalStyles.closeGlyph}>✕</Text>
      </Box>

      <Box className={modalStyles.heroWrap}>
        <img
          src={`assets/svg/scan-question.svg`}
          alt=""
          width={322}
          height={243}
          className={modalStyles.illustration}
        />
      </Box>

      <Text className={modalStyles.title}>Upload. Send. Solve.</Text>
      <Text className={modalStyles.body}>
        Upload a picture of your question to get{" "}
        <span className={modalStyles.bodyBold}>
          step-by-step solutions and answers.
        </span>
      </Text>

      <Box className={modalStyles.ctaRow}>
        <Button
          variant="primary"
          onPress={onLetsTry}
          className={modalStyles.ctaButton}
        >
          <Text className={modalStyles.ctaLabel}>Let’s Try</Text>
        </Button>
      </Box>
    </Box>
  );

  return (
    <Modal
      isModalOpen={open}
      onClose={onClose}
      showHeader={false}
      showFooter={false}
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      overLayColor="rgba(20, 20, 43, 0.5)"
      body={body}
      styles={uploadQuestionIntroModalShellStyles}
    />
  );
}
